import React, { FC, ReactNode, useState } from 'react';
import { CreateShopFormType, ShopPolygonType } from 'utils/types';
import { days } from 'utils/constants';
import { getWorkingHoursComponentFormatFromApi } from 'utils/functions';
import { NewShopContext } from './context';

const NewShopProvider: FC<{ children: ReactNode }> = ({ children }) => {
  const daysArray = getWorkingHoursComponentFormatFromApi(days());

  const [createShopForm, setCreateShopForm] = useState<CreateShopFormType>({
    brand_keywords: [],
    brand_business_metadatas: [],
    brand_descriptive_metadatas: [],
    brand_working_hours: daysArray,
    name: '',
    description: '',
    summary: '',
    pop_up: false,
    images: [],
    popup_color: '',
    slug: '',
    short_text: '',
    logo: '',
    phone: '',
    email: '',
    address: {
      address_line: '',
      latitude: 0,
      longitude: 0,
      street: '',
      state: '',
      city: '',
      country: '',
      country_code: ''
    },
    polygon: [],
    brandStatustext: '',
    shopStatus: [],
    shop_polygons: [],
    platform_fee: 0,
    platform_fee_cap: 0,
    service_fee: 0,
    service_fee_cap: 0
  });
  const [polygons, setPolygons] = useState<ShopPolygonType[]>([]);
  const [disabled, setDisabled] = useState(false);
  const [activePolygon, setActivePolygon] = useState<ShopPolygonType | null>(null);

  return (
    <NewShopContext.Provider
      value={{
        createShopForm,
        setCreateShopForm,
        disabled,
        setDisabled,
        polygons,
        setPolygons,
        setActivePolygon,
        activePolygon
      }}>
      {children}
    </NewShopContext.Provider>
  );
};

export default NewShopProvider;
